// extracted by mini-css-extract-plugin
module.exports = {"label-color":"_CheckProfileField_label-color_2Ot1U"};